'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_ImportRequest(url) {
  this.Sm = null;
  this.Sm = url;
}
export { $c_Lmealorama_ImportRequest as $c_Lmealorama_ImportRequest };
$p = $c_Lmealorama_ImportRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ImportRequest;
/** @constructor */
function $h_Lmealorama_ImportRequest() {
}
export { $h_Lmealorama_ImportRequest as $h_Lmealorama_ImportRequest };
$h_Lmealorama_ImportRequest.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-2109004614), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lmealorama_ImportRequest) && (this.Sm === x$0.Sm)));
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "ImportRequest";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.Sm;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_ImportRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jC)));
}
export { $isArrayOf_Lmealorama_ImportRequest as $isArrayOf_Lmealorama_ImportRequest };
var $d_Lmealorama_ImportRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ImportRequest, "mealorama.ImportRequest", ({
  jC: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_ImportRequest as $d_Lmealorama_ImportRequest };
//# sourceMappingURL=mealorama.-Import-Request.js.map
